import { render, staticRenderFns } from "./ordering.vue?vue&type=template&id=5afba824&scoped=true"
import script from "./ordering.vue?vue&type=script&lang=ts"
export * from "./ordering.vue?vue&type=script&lang=ts"
import style0 from "./ordering.vue?vue&type=style&index=0&id=5afba824&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afba824",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/frontend_page_elephant/frontend_page_elephant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5afba824')) {
      api.createRecord('5afba824', component.options)
    } else {
      api.reload('5afba824', component.options)
    }
    module.hot.accept("./ordering.vue?vue&type=template&id=5afba824&scoped=true", function () {
      api.rerender('5afba824', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/ordering.vue"
export default component.exports